import { Outlet, Navigate } from "react-router-dom";

export const userObj = JSON.parse(localStorage.getItem('user'));
const CustomerRoutes = () => {
    const userRole = userObj?.role[0]

    return (
        userRole.toLowerCase() !== 'partner' ? <Outlet/> : <Navigate to={`/dashboard/partner`}/>
    )
}

export default CustomerRoutes;